<nav *ngIf="show" aria-label="Breadcrumb" class="bc">
  <div class="bc__container">
    <div class="bc__row">
      <!-- Back on the left (desktop) -->
      <button type="button"
              class="bc__back"
              (click)="goBack()"
              aria-label="Go back to previous page">
        <i class="fas fa-chevron-left" aria-hidden="true"></i>
        <span>Back</span>
      </button>

      <!-- Crumbs on the right (desktop) -->
      <ol class="bc__list">
        <li *ngFor="let c of crumbs; let last = last"
            class="bc__item" [class.bc__item--last]="last">
          <a *ngIf="!last && c.url" [routerLink]="c.url">{{ c.label }}</a>
          <span *ngIf="last || !c.url" aria-current="page">{{ c.label }}</span>
        </li>
      </ol>
    </div>
  </div>
</nav>
